import service from "@/utils/axios";

/**
 * 根据id获取部门树形结构
 * @method GET  /admin/dept/list/tree?id=xx
 * @param   
 *   access public
    @param {number} id  部门id
 * */
export const deptListTree = (params) => service.get('/admin/dept/list/tree', { params },);

/**
 * 根据id获取部门详情
 * @method GET  /admin/dept/info?id=xx
 * @param
 * */
export const deptInfo = (params) => service.get('/admin/dept/info', { params });

/**
 * 创建部门
 * @method POST  /admin/dept/save
 * @param
 * */
export const createDeptSave = (params) => service.post('/admin/dept/save', params, {
   headers: { 'Content-Type': 'application/json;charset=UTF-8' }
},);
/**
 * 更新部门
 * @method PUT  /admin/dept/update/{id}
 * @param
 * */
export const updateDept = (params) => service.put('/admin/dept/update/' + params.id, params, {
   headers: { 'Content-Type': 'application/json;charset=UTF-8' }
},);
/**
* 删除部门
* @method DELETE  /admin/dept/delete/{id}
* @param
* */
export const deleteDept = (param) => service.delete('/admin/dept/' + param,);

/**
 * 获取权限接口
 * @method GET  /admin/agent/list/privileges
 * @param
 * */
export const getPrivileges = (params) => service.get('/admin/agent/list/privileges', { params });

/**
* 新增代理商接口
* @method POST  /admin/agent/save
* @param
* */
export const addAgentSave = (params) => service.post('/admin/agent/save', params, {
   headers: { 'Content-Type': 'application/json;charset=UTF-8' }
},);


/**
 * @abstract 获取代理商列表
 * @method GET  /admin/agent/list/page
 * @param 
    access public
    @param {number} current 当前页码
    @param {number} size 每页大小
    @param {string} deptIds 部门id，用逗号隔开
    
 */
export const getAgentPage = (params) => service.get('/admin/agent/list/page', { params });
/**
 * @abstract 更新代理商信息
 * @method PUT  /admin/agent/update/{id}
 * @param {object} params
 *  access public
 *  @param {number} id  代理商id
 *  @param {string} email 邮箱
 *  @param {string} clientId 部门id
 *  @param {string} password 密码
 *  @param {string} address 地址
 *  @param {string} phone 手机号
 *  @param {string} language 语言
 *  @param {array} roleIds 角色id
 *  @param {number} privilegeCode 权限码
 */

export const updateAgent = (params) => service.put('/admin/agent/update/' + params.id, params, {
   headers: { 'Content-Type': 'application/json;charset=UTF-8' }
},);

/**
 * @abstract 用户绑定代理商
 * @method PUT  /admin/user/{userId}/bind/agent?agentId=xxx
 * @param {object} params
 *  access public
 *  @param {number} userId  用户id
 *  @param {number} agentId  代理商id
 */
export const userBindAgent = (params) => service.put(`/admin/user/${params.userId}/bind/agent`, params, {
   headers: { 'Content-Type': 'application/json;charset=UTF-8' }
},);


/**
 * @abstract 获取角色列表
 * @method GET  /admin/sysRole/list/all
 * @param
 */

export const sysRoleList = (params) => service.get('/admin/sysRole/list/all', { params });

/**
 * @abstract 禁用代理商
 * @method PUT  /admin/agent/disable/{agentId}
 * @param {object} params
 *  access public
 *  @param {number} agentId  代理商id
 */
export const agentDisable = (agentId) => service.put(`/admin/agent/disable/${agentId}`);


/**
 * @abstract 启用代理商
 * @method PUT  /admin/agent/disable/{agentId}
 * @param {object} params
 *  access public
 *  @param {number} agentId  代理商id
 */
export const agentEnable = (agentId) => service.put(`/admin/agent/enable/${agentId}`);

/**
 * 获取组织管理树结构
 * @param {*} params 
 * @returns 
 */
export const getDeptTree = (params) => service.get('/system/dept/treeSelect', { params });

/**
 * 获取组织管理列表
 * @param {*} params 
 * @returns 
 */
export const getDeptList = (params) => service.get('/system/dept/list', { params });

/**
 * 获取部门信息
 * @param {*} params 
 * @returns 
 */
export const getDeptInfo = (params) => service.get(`/system/dept/${params.deptId}`);

/**
 * 获取树节点对应用户列表
 * @param {*} params 
 * @returns 
 */
export const getAgentList = (params) => service.get('/system/agent/list', { params });

/**
 * 新增用户
 * @param {*} params 
 * @returns 
 */
export const postAgent = (params) => service.post('/system/agent', params, {
   headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

/**
 * 修改用户
 * @param {*} params 
 * @returns 
 */
export const putAgent = (params) => service.put('/system/agent', params, {
   headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

/**
 * 获取oss的token信息
 * @param {*} params 
 * @returns 
 */
export const getSignture = (params) => service.post('/system/oss/signature', { params });

/**
 * 上传文件
 * @param {*} params 
 * @returns 
 */
export const uploadFile = (params) => service.post('/system/oss/upload', params);

/**
 * 国家和地区列表
 * @param {*} params 
 * @returns 
 */
export const getCountryList = (params) => service.get('/system/dept/getCountryList', { params });

/**
 * 获取国家对应时区接口
 */
export const getCountryMap = (params) => service.get('/system/sysDictType/getCountryMap', { params });

/**
 * 获取国家时区列表
 * @param {*} params 
 * @returns 
 * Array
 * @param {number} id 国家id
 * @param {string} adcCode 国家时区代码
 * @param {string} name  国家时区名称
 * @param {number} timeZone  时区
 */
export const getCountryTimeZoneList = (params) => service.get('/meta/country/getCountryTimeZoneList', { params });

/**
 * 新增部门
 * @param {*} params 
 * @returns 
 */
export const postDept = (params) => service.post('/system/dept', params, {
   headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

/**
 * 编辑部门
 * @param {*} params 
 * @returns 
 */
export const putDept = (params) => service.put('/system/dept', params, {
   headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

/**
 * 获取部门详情
 * @param {*} params 
 * @returns 
 */
export const getDept = (params) => service.get(`/system/dept/${params.id}`, { params });

/**
 * 删除部门
 * @param {*} params 
 * @returns 
 */
export const delDept = (params) => service.delete(`/system/dept/${params.id}`);

/**
 * 获取角色管理列表
 * @param {*} params 
 * @returns 
 */
export const getRoleList = (params) => service.get('/system/role/list', { params });

/**
 * 获取选择角色列表
 */
export const getRoleSelect = (params) => service.get('/system/role/getRoleList', { params });

/**
 * 获取当前用户角色列表
 */
export const getRoleListByToken = (params) => service.get('/system/role/getRoleListByToken', { params });

/**
 * 重置密码
 * @param {*} params 
 * @returns 
 */
export const resetPassword = (params) => service.post('/system/agent/resetPassword', params, {
   headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

/**
 * 改变用户状态
 * @param {*} params id status
 * @returns 
 */
export const changeStatus = (params) => service.post('/system/agent/changeStatus', params, {
   headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});

/**
 * 查询字典所有数据
 * @method GET
 * @param {Object } params
 * @param {Number} params.dictType
 * */
export const getAllSysDictType = (params) => service.get('/system/sysDictType', { params });

// 申请绿色通道
// @method GET  /agent/tempAuthApply?agentId=
export const tempAuthApply = (params) => service.post(`/system/agent/tempAuthApply?agentId=${params.agentId}`, params, {
   headers: { 'Content-Type': 'application/json;charset=UTF-8' }
});
